import { render } from "./DietPage.vue?vue&type=template&id=0b50ee6a"
import script from "./DietPage.vue?vue&type=script&lang=js"
export * from "./DietPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__